export default __webpack_public_path__ + "static/media/start-own-illustration.c1bbbe18.png";